<mat-progress-bar mode="indeterminate" *ngIf="builderService.showUpdateProgress"></mat-progress-bar>

<div class="genie-page" id="PnAutomationWrapper">

  <!-- Back Button -->
  <div class="backButton" (click)="builderService.navigateBack()">
    <img src="/assets/icons/arrow-left.svg" alt="Go back" />
  </div>

  <!-- Page Header -->
  <div class="page-header">
    <div class="header-info">
      <p class="page-title">{{ 'Automation' | translate }}</p>
      <p class="page-subtitle">{{ 'Automatically notify users based on store events.' | translate }}</p>
    </div>
    <div class="header-actions">
      <button type="button" class="cancel-btn" (click)="builderService.navigateBack()">
        <span>{{ 'Cancel' | translate }}</span>
      </button>
      <button type="button" class="submit-btn" (click)="save()" [disabled]="!newEventData">
        <span>{{ 'Save' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="genie-content-card">

    <!-- Toolbar -->
    <div class="genie-toolbar">
      <form (ngSubmit)="onSubmit()" class="search-input-wrapper toolbar-search">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <input type="text" placeholder="{{ 'Search...' | translate }}" [(ngModel)]="searchKey" name="search" />
      </form>
      <div class="toolbar-right">
        <button type="button" class="genie-btn primary" (click)="addEvent()">
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.36589 0.699219V10.0326M0.699219 5.36589H10.0326" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ 'Add New Event' | translate }}
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="genie-table-wrapper">
      <div class="table-scroll">
      <table class="genie-table">
        <thead>
          <tr>
            <th class="col-id">{{ 'ID' | translate }}</th>
            <th class="col-event">{{ 'Event' | translate }}</th>
            <th class="col-notify">{{ 'When Send Notify' | translate }}</th>
            <th class="col-message">{{ 'Message' | translate }}</th>
            <th class="col-date">{{ 'Date' | translate }}</th>
            <th class="col-actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of dataSource.data | slice: ((paginator.pageIndex || 0) * pageSize) : (((paginator.pageIndex || 0) + 1) * pageSize); let i = index">
            <td class="col-id">{{ element.id }}</td>
            <td class="col-event">
              <div class="cell-field-wrapper">
                <div class="np-custom-select" (click)="toggleCellDropdown(i + '-type', $event)">
                  <span class="select-value">{{ element.selectedType || ('Select...' | translate) }}</span>
                  <img src="/assets/icons/arrow-down.svg" width="12" height="12" alt="" class="select-arrow" [class.open]="isCellDropdownOpen(i + '-type')" />
                </div>
                <div class="np-dropdown-panel" *ngIf="isCellDropdownOpen(i + '-type')"
                     [style.top.px]="dropdownPosition[i + '-type'].top"
                     [style.left.px]="dropdownPosition[i + '-type'].left"
                     [style.width.px]="dropdownPosition[i + '-type'].width"
                     (click)="$event.stopPropagation()">
                  <div class="np-dropdown-option"
                       *ngFor="let typeOption of element.types"
                       [class.selected]="element.selectedType === typeOption"
                       (click)="selectCellOption(element, 'type', typeOption, $event)">
                    {{ typeOption }}
                    <svg *ngIf="element.selectedType === typeOption" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 6L5 9L10 3" stroke="#3A95B9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
            <td class="col-notify">
              <div class="cell-field-wrapper">
                <div class="np-custom-select" (click)="toggleCellDropdown(i + '-name', $event)">
                  <span class="select-value">{{ element.name || ('Select...' | translate) }}</span>
                  <img src="/assets/icons/arrow-down.svg" width="12" height="12" alt="" class="select-arrow" [class.open]="isCellDropdownOpen(i + '-name')" />
                </div>
                <div class="np-dropdown-panel" *ngIf="isCellDropdownOpen(i + '-name')"
                     [style.top.px]="dropdownPosition[i + '-name'].top"
                     [style.left.px]="dropdownPosition[i + '-name'].left"
                     [style.width.px]="dropdownPosition[i + '-name'].width"
                     (click)="$event.stopPropagation()">
                  <div class="np-dropdown-option"
                       *ngFor="let nameOption of pnService.nameOptions"
                       [class.selected]="element.name === nameOption"
                       (click)="selectCellOption(element, 'name', nameOption, $event)">
                    {{ nameOption }}
                    <svg *ngIf="element.name === nameOption" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 6L5 9L10 3" stroke="#3A95B9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
            <td class="col-message">
              <input
                class="cell-input"
                type="text"
                [(ngModel)]="element.selectedMessage"
                (ngModelChange)="onMessageChange(element)"
                placeholder="{{ 'Enter message...' | translate }}"
              />
            </td>
            <td class="col-date">{{ element.date }}</td>
            <td class="col-actions">
              <div class="genie-action-buttons">
                <button class="genie-icon-btn delete" (click)="delete(i)">
                  <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.53438 3.13438V2.65438C8.53438 1.98231 8.53438 1.64628 8.40358 1.38959C8.28854 1.16379 8.10496 0.980215 7.87916 0.865167C7.62247 0.734375 7.28644 0.734375 6.61438 0.734375H5.65438C4.98231 0.734375 4.64628 0.734375 4.38959 0.865167C4.16379 0.980215 3.98022 1.16379 3.86517 1.38959C3.73438 1.64628 3.73438 1.98231 3.73438 2.65438V3.13438M4.93438 6.43438V9.43438M7.33438 6.43438V9.43438M0.734375 3.13438H11.5344M10.3344 3.13438V9.85438C10.3344 10.8625 10.3344 11.3665 10.1382 11.7516C9.96562 12.0903 9.69025 12.3656 9.35156 12.5382C8.96652 12.7344 8.46247 12.7344 7.45438 12.7344H4.81438C3.80628 12.7344 3.30223 12.7344 2.91719 12.5382C2.5785 12.3656 2.30314 12.0903 2.13056 11.7516C1.93437 11.3665 1.93438 10.8625 1.93438 9.85438V3.13438" stroke="#ADADAD" stroke-width="1.467" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!chosenEvents?.length">
            <td colspan="6" class="empty-cell">{{ 'No automation events found.' | translate }}</td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

    <!-- Hidden Paginator (state management only) -->
    <mat-paginator
      class="hidden-paginator"
      [length]="length"
      [pageSize]="pageSize"
      aria-label="Select page">
    </mat-paginator>

    <!-- Custom Pagination UI -->
    <div class="genie-pagination">
      <div class="pagination-info">
        <span class="current-page">{{ (paginator.pageIndex || 0) + 1 }}</span>
        <span class="page-separator">{{ 'of' | translate }}</span>
        <span class="total-pages">{{ paginator.getNumberOfPages() || 1 }}</span>
      </div>
      <div class="pagination-controls">
        <button class="page-btn prev" (click)="paginator.previousPage()" [disabled]="!paginator.hasPreviousPage()">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="page-btn next" (click)="paginator.nextPage()" [disabled]="!paginator.hasNextPage()">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

  </div>

</div>
